const state = () => ({
	accessToken: null,
	refreshToken: null,
	//keepLogin: false, //autoLogin 주석처리
	id: null,
	name: null,
	credentialsNonExpired: true,
    smsLoginData: null,
    smsLoginId: null,
    verificationMethod: 'mobile'
});

const getters = {
	getLoginModule: (state) => ({
		accessToken: state.accessToken,
		refreshToken: state.refreshToken,
		// keepLogin: state.keepLogin,  //autoLogin 주석처리
		id: state.name,
		name: state.id,
		credentialsNonExpired: state.credentialsNonExpired
	}),
	getAccessToken: state => state.accessToken,
	getRefreshToken: state => state.refreshToken,
	// getKeepLogin: state => state.keepLogin,  //autoLogin 주석처리
	getName: state => state.name,
	getId: state => state.id,
	getCredentialsNonExpired: state => state.credentialsNonExpired,
    getSmsLoginData: state => state.smsLoginData,
    getSmsLoginId: state => state.smsLoginId,
    getVerificationMethod: state => state.verificationMethod
};

const actions = {
	saveLoginData({ commit }, loginData) {
		commit('SET_ACCESS_TOKEN', loginData.accessToken);
		commit('SET_REFRESH_TOKEN', loginData.refreshToken);
		// commit('SET_KEEP_LOGIN', loginData.keepLogin);   //autoLogin 주석처리
		commit('SET_CREDENTIAL', loginData.credentialsNonExpired);
	},
	setId({ commit }, item) {
		commit('SET_ID', item);
	},
	setName({ commit }, item) {
		commit('SET_NAME', item);
	},
    setSmsLoginData({commit},item) {
        commit('SET_SMS_LOGIN_DATA',item);
    },
    setSmsLoginId({commit},item) {
        commit('SET_SMS_LOGIN_ID',item);
    },
    setVerificationMethod({commit},item) {
        commit('SET_VERIFICATION_METHOD',item);
    },
	logout({ commit }) {
		commit('INITIALIZE_ACCESS_TOKEN');
		commit('INITIALIZE_REFRESH_TOKEN');
		commit('SET_ID', null);
		commit('SET_NAME', null);
		commit('SET_CREDENTIAL', true); // or false
		commit('SET_SMS_LOGIN_DATA', null);
		commit('SET_SMS_LOGIN_ID', null);
	}
};

const mutations = {
	INITIALIZE_ACCESS_TOKEN(state) {
		state.accessToken = null;
	},
	INITIALIZE_REFRESH_TOKEN(state) {
		state.refreshToken = null;
	},
	SET_ACCESS_TOKEN(state, payload) {
		state.accessToken = payload;
	},
	SET_REFRESH_TOKEN(state, payload) {
		state.refreshToken = payload;
	},
	// SET_KEEP_LOGIN(state, keepLogin) {   //autoLogin 주석처리
	// 	state.keepLogin = keepLogin;
	// },
	SET_CREDENTIAL(state, credentialsNonExpired) {
		state.credentialsNonExpired = credentialsNonExpired;
	},
	SET_ID(state, item) {
		state.id = item;
	},
	SET_NAME(state, item) {
		state.name = item;
	},
    SET_SMS_LOGIN_DATA(state,item) {
        state.smsLoginData = item;
    },
    SET_SMS_LOGIN_ID(state,item) {
        state.smsLoginId = item;
    },
    SET_VERIFICATION_METHOD(state,item) {
        state.verificationMethod = item;
    },
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
